import screenfull from 'screenfull'

import Emitter from './emitter'
import StrictObj from './strict-obj'

import { onEventPassive } from './on-event'

export default jsFullscreenProvider()

function jsFullscreenProvider() {
  const rootExitEmitter = Emitter('jsFullscreen::rootExit')
  const rootToggleEmitter = Emitter('jsFullscreen::rootToggle')
  const rootRequestEmitter = Emitter('jsFullscreen::rootRequest')

  let lastIsRootFullscreen = isRootFullscreen()

  if (screenfull.isEnabled) {
    onEventPassive(document, screenfull.raw.fullscreenchange, fullscreenChangeHandler)
  }

  return StrictObj({
    exit,
    request,
    isEnabled,

    isRootFullscreen,

    rootExitEmitter,
    rootToggleEmitter,
    rootRequestEmitter
  })

  function fullscreenChangeHandler() {
    if (lastIsRootFullscreen !== isRootFullscreen()) {
      lastIsRootFullscreen = isRootFullscreen()

      rootToggleEmitter.emit()
      lastIsRootFullscreen
        ? rootRequestEmitter.emit()
        : rootExitEmitter.emit()
    }
  }

  function isRootFullscreen() {
    return true
      && screenfull.isFullscreen
      && screenfull.element === document.documentElement
  }

  function isEnabled() {
    return screenfull.isEnabled
  }

  function request() {
    return screenfull.request(document.documentElement)
  }

  function exit() {
    return screenfull.exit()
  }
}
